/* ===== Etchwell — Product configurator ===== */
(function(){
  const $=s=>document.querySelector(s), $$=s=>document.querySelectorAll(s);
  const pText=$('#pText'), pRect=$('#pRect');
  const fields=$('#fields'), totalEl=$('#totalPrice'), nowEl=$('#priceNow'), wasEl=$('#priceWas');
  const perPen=$('#perPen'), penCount=$('#penCount'), colName=$('#colName');
  if(!pText) return;

  const PRICE={
    1:{now:19.95,was:29.95,per:'$19.95 / pen'},
    3:{now:44.95,was:59.95,per:'$14.98 / pen'},
    4:{now:54.95,was:74.95,per:'$13.74 / pen'},
    6:{now:74.95,was:104.95,per:'$12.49 / pen'}
  };
  let qty=1, base=19.95, addons=0, barrel='#39342d';

  const fmt=n=>'$'+n.toFixed(2);
  function shade(hex,p){const n=parseInt(hex.slice(1),16);const a=v=>Math.max(0,Math.min(255,Math.round(v*(1+p))));return '#'+[a(n>>16&255),a(n>>8&255),a(n&255)].map(x=>x.toString(16).padStart(2,'0')).join('');}

  function recalc(){
    base=PRICE[qty].now;
    const total=base+addons;
    totalEl.textContent=fmt(total);
    nowEl.textContent=fmt(base); wasEl.textContent=fmt(PRICE[qty].was);
    perPen.textContent=PRICE[qty].per;
    penCount.textContent=qty+(qty>1?' pens':' pen');
  }

  function buildFields(){
    const cur=[...fields.querySelectorAll('input')].map(i=>i.value);
    fields.innerHTML='';
    for(let i=0;i<qty;i++){
      const inp=document.createElement('input');
      inp.type='text'; inp.maxLength=22; inp.dataset.i=i;
      inp.placeholder='Name or message — pen '+(i+1);
      inp.value=cur[i]|| (i===0?'Olivia':'');
      if(i===0) inp.addEventListener('input',preview);
      fields.appendChild(inp);
    }
  }

  function preview(){
    const v=fields.querySelector('input')?.value||'Your name';
    pText.textContent=v;
    pText.setAttribute('font-size', v.length>14?22:v.length>9?27:32);
    if(window.gsap) gsap.fromTo(pText,{opacity:.25},{opacity:1,duration:.4});
  }

  // set pills
  $('#setPills').addEventListener('click',e=>{
    const b=e.target.closest('.pill'); if(!b) return;
    $$('#setPills .pill').forEach(x=>x.setAttribute('aria-pressed',x===b));
    qty=+b.dataset.qty; buildFields(); recalc();
  });

  // colour
  $('#pSwatches').addEventListener('click',e=>{
    const b=e.target.closest('.sw'); if(!b) return;
    $$('#pSwatches .sw').forEach(x=>x.setAttribute('aria-pressed',x===b));
    barrel=b.dataset.barrel; colName.textContent=b.dataset.name;
    const g=$('#pBarrel');
    g.children[0].setAttribute('stop-color',shade(barrel,.35));
    g.children[1].setAttribute('stop-color',barrel);
    g.children[2].setAttribute('stop-color',shade(barrel,-.28));
    pText.style.fill=(barrel==='#d8a988'||barrel==='#8a9a7e')?'#2a261f':'#f3e7d8';
    if(window.gsap) gsap.fromTo(pRect,{scaleX:.985,transformOrigin:'50% 50%'},{scaleX:1,duration:.45,ease:'back.out(2)'});
  });

  // font
  $('#pFonts').addEventListener('click',e=>{
    const b=e.target.closest('.pill'); if(!b) return;
    $$('#pFonts .pill').forEach(x=>x.setAttribute('aria-pressed',x===b));
    pText.style.fontFamily=b.dataset.font; pText.style.fontStyle=b.dataset.style;
  });

  // add-ons
  $('#addons').addEventListener('change',()=>{
    addons=[...$$('#addons input:checked')].reduce((s,i)=>s+ +i.dataset.add,0);
    recalc();
  });

  // gallery
  const galMain=$('#galMain');
  $('#thumbs').addEventListener('click',e=>{
    const b=e.target.closest('button'); if(!b) return;
    $$('#thumbs button').forEach(x=>x.setAttribute('aria-pressed',x===b));
    if(window.gsap) gsap.fromTo(galMain,{opacity:.3},{opacity:1,duration:.4});
    galMain.src=b.dataset.src;
  });

  // add to cart (Phase 0 — friendly stub until checkout is wired)
  $('#addCart').addEventListener('click',()=>{
    const cfg={qty, colour:colName.textContent, total:totalEl.textContent,
      names:[...fields.querySelectorAll('input')].map(i=>i.value).filter(Boolean)};
    console.log('Etchwell add-to-cart',cfg);
    const btn=$('#addCart'); const label=btn.querySelector('span');
    const old=label.innerHTML;
    label.innerHTML='✓ Added — '+cfg.total;
    if(window.gsap) gsap.fromTo(btn,{scale:.97},{scale:1,duration:.4,ease:'back.out(2)'});
    setTimeout(()=>label.innerHTML=old,1800);
  });

  buildFields(); recalc();
})();
